module.exports = "<div class=\"gw-tile-action__inside\" gw-partial=\"Item\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/Actions/TileAction.html
// module id = 961
// module chunks = 0